// React
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { Stack } from "@mui/material";
import { MBSPaperCard } from "Common/Components";
import { RenderQRCode } from "Components/QRCode";
import SearchCard from "./SearchCard";

// Icons
import {
  QrCodeScanner,
  Search,
  PersonSearchOutlined,
} from "@mui/icons-material";

// Libraries
import { useTranslation } from "react-i18next";

const MBSHomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isQROpen, setIsQROpen] = useState(false);

  const handleQRCodeRead = (qrJSON) => {
    setIsQROpen(false);
    navigate("/mbs/search", { state: { scannedCard: qrJSON } });
  };

  return (
    <MBSPaperCard icon={<PersonSearchOutlined />} title={t("mbsHome.title")}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <SearchCard
          icon={<Search color="primary" />}
          title={t("mbsHome.patientInformationTitle")}
          description={t("mbsHome.patientInformationDescription")}
          borderColor="primary.main"
          onClick={() => navigate("/mbs/search")}
        />
        <SearchCard
          icon={<QrCodeScanner color="primary" />}
          title={t("mbsHome.scanHealthCardQrTitle")}
          description={t("mbsHome.scanHealthCardQrDescription")}
          borderColor="secondary.main"
          onClick={() => setIsQROpen(true)}
        />
        {isQROpen && (
          <RenderQRCode
            onSuccess={handleQRCodeRead}
            onDialogClose={() => setIsQROpen(false)}
            altCloseLabel={t("mbsSearch.search")}
          />
        )}
      </Stack>
    </MBSPaperCard>
  );
};

export default MBSHomePage;
